<template>

  <header>
    <div class="w-100 flex justify-center h-20">
      <img src="@/assets/images/logo.png" alt="logo">
    </div>
    <!-- <div class="bg-purple py-4 container-fluid mx-auto flex justify-center items-center h-10">
      <div class="w-2/4 flex justify-between items-center">
        <nav class="hidden md:flex space-x-4">
          <router-link to="/" class="text-white hover:underline">HOME</router-link>
          <router-link to="/about" class="text-white hover:underline">ABOUT</router-link>
          <router-link to="/universities" class="text-white hover:underline">UNIVERSITIES</router-link>
          <router-link to="/blogs" class="text-white hover:underline">BLOGS</router-link>
          <router-link to="/contact" class="text-white hover:underline">CONTACT</router-link>
        </nav>
        <div class="ml-5 space-x-4">
          <router-link to="/login" class="text-white hover:underline">LOGIN</router-link>
          <router-link to="/signup" class="">
            <button class="bg-lightPink text-purple-600 p-2 rounded shadow">SIGN UP</button>
          </router-link>
        </div>

      </div>
      
    </div> -->
    <div class="bg-purple py-4 container-fluid mx-auto flex justify-center items-center h-10">
      <div class="container mx-auto flex justify-between items-center w-3/5">
        <!-- Navigation Links -->
        <nav class="flex space-x-6 items-center text-white text-sm uppercase font-bold">
          <router-link to="/" class="hover:underline">HOME</router-link>
          <span class="border-r border-white h-5"></span>
          <router-link to="/about" class="hover:underline">ABOUT</router-link>
          <span class="border-r border-white h-5"></span>
          <router-link to="/universities" class="hover:underline">UNIVERSITIES</router-link>
          <span class="border-r border-white h-5"></span>
          <router-link to="/blogs" class="hover:underline">BLOGS</router-link>
          <span class="border-r border-white h-5"></span>
          <router-link to="/contact" class="hover:underline">CONTACT</router-link>
        </nav>

        <div class="flex items-center space-x-4">
          <router-link to="/login" class="text-white hover:underline text-sm">LOGIN</router-link>
          <router-link to="/signup">
            <button
              class="bg-white text-purer py-1.5 px-4 rounded-full text-sm font-bold hover:bg-gray-100 shadow-md">
              SIGN UP
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </header>

</template>

<script>
export default {
  name: 'AppHeader',
}
</script>

<style scoped></style>
